
import { map } from 'rxjs/operators';

import { Inject, Injectable } from '@angular/core';

import { ServerApi } from '../services/server-api';
import { Session } from '../services/session';

import { extractResponseBody } from '../lib/utils';

import { DEFAULT_TIME_ZONE } from '../lib/time-zones';
import { DEFAULT_LANGUAGE } from '../lib/supported-languages';

@Injectable()
export class SettingsAccount {
  private endpoint;

  constructor(@Inject(ServerApi) private api, @Inject(Session) session) {
    const id = session.getUserId();
    this.endpoint = `users/${id}`;
  }

  public get(id) {
    return this.api.get(this.endpoint)
      .pipe(
        map(extractResponseBody),
        map(this._transformData.bind(this)),
      )
    ;
  }

  public save(data) {
    return this.api.put(this.endpoint, data);
  }

  private _transformData(res) {
    const user = res.user;
    const timeZone = user.time_zone || DEFAULT_TIME_ZONE;
    const language = user.language || DEFAULT_LANGUAGE;

    return {
      firstName: user.first_name,
      lastName: user.last_name,
      driverId: user.driver_company_id,
      driverLicenseState: user.drivers_license_state,
      driverLicenseNumber: user.drivers_license_number,
      email: user.email,
      username: user.username,
      phone: user.phone,
      phoneCountryCode: user.phone_country_code,
      timeZone,
      metricUnits: user.metric_units,
      language,
      isCompanyConnectionApproved: user.company_connection && user.company_connection.status === 'active',
      fuelEconomyUnit: user.fuel_economy_unit,
      videoDisplayPreference: user.video_display_preference,
      appVersion: user.app_version,
    };
  }
}
